import Statistics from '../components/Statistics/StatisticsList'
import Complex from '../components/Statistics/Complex'
import Drivers from '../components/Drivers/DriverList'
import Sets from '../components/Sets/Sets'

const routes = [
  {
    path: '',
    name: 'analytics_old.statistics',
    component: Statistics
  },
  {
    path: 'complex',
    name: 'analytics_old.complex',
    component: Complex
  },
  {
    path: 'sets',
    name: 'analytics_old.sets',
    component: Sets
  },
  {
    path: 'drivers',
    name: 'analytics_old.drivers',
    component: Drivers
  },
]

export default routes



// WEBPACK FOOTER //
// ./src/apps/analytics_old/router/routes.js